import { createEntityFilterStore } from "./createEntityFilterStore";
import type { InvestorFilters } from "@/domain/types";

const initialFilters: InvestorFilters = {
	search: "",
	status: "",
	type: "",
	sort: { key: undefined, direction: null },
};

export const useInvestorFiltersStore = createEntityFilterStore<InvestorFilters>(
	"InvestorFiltersStore",
	initialFilters,
);
